import React, { useState, useEffect } from "react";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import { toast } from "react-toastify";
import { handleLogOut } from "../../utils/ClearCache";

import {
  editSla,
  fetchCategoriesAndSubCategories,
  fetchDepartment,
  fetchSLADurations,
  fetchTag,
  fetchWorkFlow,
  submitSlaData,
} from "../../utils/API/TicketAPI";
import { useToken } from "../../utils/TokenContext";
import NoDataBg from "../../assests/img/No-data-bg.svg";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { MultiSelect } from "react-multi-select-component";
import { Link } from "react-router-dom";
import PencilIcon from "../../assests/img/pencil.svg";
import TimeIcon from "./img/time-icon.svg";

function SLADurations({}) {
  const [loading, setLoading] = useState(false);
  const [showInternalSla, setShowInternalSla] = useState(false); 
  const [sla, setSla] = useState([]);
  // const [isValidToken, setIsValidToken] = useState(true);
  const [sortDirection, setSortDirection] = useState("asc");
  const [sortColumn, setSortColumn] = useState(null);
  const [activeTabTicket, setActiveTabTicket] = useState("open");
  // SLA Add/Edit Modal
  const [showAddSlaModal, setShowAddSlaModal] = useState(false);

  const [editMode, setEditMode] = useState(false); // New state for edit mode
  const [editSlaId, setEditSlaId] = useState(null);

  const [defaultHrs, setDefaultHrs] = useState("");
  const [internalSlaHrs, setInternalSlaHrs] = useState("");

  const [defaultMins, setDefaultMins] = useState("");

  const [slaMins, setSlaMins] = useState("");
  const [e1Hrs, setE1Hrs] = useState("");
  const [e1Mins, setE1Mins] = useState("");
  const [e2Hrs, setE2Hrs] = useState("");
  const [e2Mins, setE2Mins] = useState("");
  const [e3Hrs, setE3Hrs] = useState("");
  const [e3Mins, setE3Mins] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedDepartment1, setSelectedDepartment1] = useState([]);

  const [selectedCategories, setSelectedCategories] = useState("");
  const [categoryOptions, setCategoryOptions] = useState("");
  const [allSubCategoryOptions, setAllSubCategoryOptions] = useState([]);
  const [filteredSubCategoryOptions, setFilteredSubCategoryOptions] = useState(
    []
  );
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [isInternal, setIsInternal] = useState(true);
  const [isCentralLocation , setIsCentralLocation] = useState(true);
  const [spocOnly, setSpocOnly] = useState(true);
  const [workFlow, setWorkFlow] = useState([]);
  const [workflowOptions, setWorkflowOptions] = useState([]);
  const [irrelevant, setIrrelevant] = useState(true);


 // Store the tag options
  const [selectedTag, setSelectedTag] = useState(''); 
  const [departmentOptions, setDepartmentOptions] = useState([]);

  const [tagOptions, setTagOptions] = useState([]); // To hold options
  const [selectedTags, setSelectedTags] = useState([]);
  const editAccess = localStorage.getItem('editAccess');
  const hasCategory = editAccess && editAccess.includes('Category Manager');
  console.log("hasCategory",editAccess)

  const handleAddSlaModalClose = () => {
    setShowAddSlaModal(false);
    setEditMode(false); // Reset edit mode
    clearForm();
  };
  const handleAddSlaModalShow = () => {
    setShowAddSlaModal(true);
  };
  const handleEditSlaModalShow = (slaData) => {
    // Set edit mode to true first
    setEditMode(true);
    
  
    // Log to verify if editMode is set correctly

  console.log("fshsjdkf",editMode)
    setEditSlaId(slaData._id);
    setSelectedCategories(slaData.category);
    setSelectedSubCategories(slaData.subCategory);
    setSelectedDepartment(slaData?.groupType);
  
    // Convert tags to the format expected by MultiSelect
    const formattedTags = slaData?.tags?.map(tag => ({
      value: tag,
      label: tag,
    })) || [];
    setSelectedTags(formattedTags);
  
    // Convert groupWiseDueTime to match the department options format
    const groupWiseDueTime = Array.isArray(slaData?.groupWiseDueTime) ? slaData.groupWiseDueTime : [];

    console.log("Raw groupWiseDueTime from slaData:", groupWiseDueTime);
    
    // Map groupWiseDueTime to populate the form fields
    const formattedDepartments = groupWiseDueTime.map(dept => {
      // Debugging each department entry
      console.log("Mapping department:", dept);
    
      // Ensure groupType and _id are present
      return {
        value: dept.groupType || '', // Default to empty string if not found
        label: dept.groupType?.toUpperCase() || '', // Default to empty string if not found
        _id: dept._id || null // Handle cases where _id might be missing
      };
    });
    
    // Debugging the formatted output
    console.log("Formatted Departments:", formattedDepartments);
    
    // Update the state with the mapped values
    setSelectedDepartment1(formattedDepartments);
  
    setSelectedDepartment1(formattedDepartments); // Set selectedDepartment1 for MultiSelect
  
    // Populate internalSlaHrs and slaMins from groupWiseDueTime
    const newInternalSlaHrs = {};
    const newSlaMins = {};
  
    groupWiseDueTime.forEach(dept => {
      const hours = Math.floor(dept.time); // Extract hours
      const minutes = ('' + dept.time).split('.')[1] ? ('' + dept.time).split('.')[1] * 6 : 0;
      newInternalSlaHrs[dept.groupType] = hours;
      newSlaMins[dept.groupType] = minutes;
    });
  
    setInternalSlaHrs(newInternalSlaHrs);
    setSlaMins(newSlaMins);
  
    // Set other SLA fields
    setWorkFlow(slaData.workflow);
    setIsInternal(slaData.internalOnly);
    setSpocOnly(slaData.spocOnly);
    setIrrelevant(slaData.isIrrelevant);
    setIsCentralLocation(slaData.isCentralLocation);
  
    setDefaultHrs(Math.floor(slaData.defaultDueTime));
    setDefaultMins(('' + slaData.defaultDueTime).split('.')[1] ? ('' + slaData.defaultDueTime).split('.')[1] * 6 : "");
  
    setE1Hrs(Math.floor(slaData.escalationTime1));
    setE1Mins(('' + slaData.escalationTime1).split('.')[1] ? ('' + slaData.escalationTime1).split('.')[1] * 6 : "");
  
    setE2Hrs(Math.floor(slaData.escalationTime2));
    setE2Mins(('' + slaData.escalationTime2).split('.')[1] ? ('' + slaData.escalationTime2).split('.')[1] * 6 : "");
  
    setE3Hrs(Math.floor(slaData.escalationTime3));
    setE3Mins(('' + slaData.escalationTime3).split('.')[1] ? ('' + slaData.escalationTime3).split('.')[1] * 6 : "");
  
    setShowAddSlaModal(true); // Finally, show the modal
  };


  useEffect(() => {

    if (editMode && workflowOptions.length > 0) {
      const selectedWorkflow = workflowOptions.find(
        (option) => option.value === editSlaId
      );
      if (selectedWorkflow) {
        setWorkFlow(selectedWorkflow.value);
      }
    }
 
    

  }, [workflowOptions, editMode, editSlaId]);

  const clearForm = () => {
    setSelectedDepartment("");
    setSelectedCategories("");
    setSelectedSubCategories("");
    setWorkFlow("");
    setIsInternal(true);
    setSpocOnly(true);
    setIsCentralLocation(true);
    setDefaultHrs("");
    setDefaultMins("");
    setE1Hrs("");
    setE1Mins("");
    setE2Hrs("");
    setE2Mins("");
    setE3Hrs("");
    setE3Mins("");
  };
  const fetchCategoriesAndSubCategoriesData = async () => {
    try {
      const response = await fetchCategoriesAndSubCategories();
      if (response.data.statusValue === 200) {
        const categories = response.data.data.map((item) => ({
          label: item.category,
          value: item.category,
        }));

        setCategoryOptions(categories);

        const subCategories = response.data.data.map((item) => ({
          category: item.category,
          subCategories: item.subCategories.map((sub) => ({
            label: sub,
            value: sub,
          })),
        }));

        setAllSubCategoryOptions(subCategories);
      } else {
        setCategoryOptions([]);
        setAllSubCategoryOptions([]);
      }
    } catch (error) {
      console.error("Error fetching categories and subcategories", error);
    }
  };

  const fetchWorkFlowList = async () => {
    try {
      const response = await fetchWorkFlow();
      if (response.data.statusValue === 200) {
        const workflowOptions = response.data.data.map((item) => ({
          label: item.name,
          value: item._id,
        }));

        setWorkflowOptions(workflowOptions);
      } else {
        setWorkflowOptions([]);
      }
    } catch (error) {
      console.error("Error fetching workflow", error);
    }
  };


  const fetchtagList = async () => {
    try {
      const response = await fetchTag(); // Make sure fetchTag is a valid function
      console.log("Response:", response);
      if (response.data.statusValue === 200) {
        const tagOptions = response.data.data.map((item) => ({
          label: item.label,
          value: item.value,
        }));
        setTagOptions(tagOptions); // Set the fetched tags in state
      } else {
        setTagOptions([]);
      }
    } catch (error) {
      console.error("Error fetching tags", error);
    }
  };



  useEffect(() => {
    fetchCategoriesAndSubCategoriesData();
    fetchWorkFlowList();
    fetchtagList()
    fetchDepartmentOptions();
  }, []);

  useEffect(() => {
    if (selectedCategories === "") {
      setFilteredSubCategoryOptions([]);
    } else {
      const filteredSubCategories = allSubCategoryOptions
        .filter((option) => option.category === selectedCategories)
        .flatMap((option) => option.subCategories);

      setFilteredSubCategoryOptions(filteredSubCategories);
    }
  }, [selectedCategories, allSubCategoryOptions]);

  const handleHoursChange = (event) => {
    setDefaultHrs(event.target.value);
  };



  const handleSlaHoursChange = (value, groupType) => {
    setInternalSlaHrs((prevHours) => ({
      ...prevHours,
      [groupType]: value, // Update only the specific groupType
    }));
  };
  
  // Handle Minutes Change
 const handleMinutesSlaChange = (value, groupType) => {
  setSlaMins((prevMinutes) => ({
    ...prevMinutes,
    [groupType]: value, // Update only the specific groupType
  }));
};
  const handleMinutesChange = (event) => {
    setDefaultMins(event.target.value);
  };


  const handleE1HoursChange = (event) => {
    setE1Hrs(event.target.value);
  };

  const handleE1MinutesChange = (event) => {
    setE1Mins(event.target.value);
  };

  const handleE2HoursChange = (event) => {
    setE2Hrs(event.target.value);
  };

  const handleE2MinutesChange = (event) => {
    setE2Mins(event.target.value);
  };

  const handleE3HoursChange = (event) => {
    setE3Hrs(event.target.value);
  };

  const handleE3MinutesChange = (event) => {
    setE3Mins(event.target.value);
  };

  const generateMinuteOptions = () => {
    const options = [];
    for (let i = 0; i < 60; i += 6) {
      options.push(
        <option key={i} value={i}>
          {i < 10 ? `0${i}` : i}
        </option>
      );
    }
    return options;
  };

  const fetchDepartmentOptions = async() => {
    try {
      const response = await fetchDepartment();
      if (response.data.statusValue === 200) {
        const departments = response.data.data.map((dept) => ({
          label: dept.label,
          value: dept.value,
        }));

       setDepartmentOptions(departments)
      } else {
        setDepartmentOptions([]);
      }
    } catch (error) {
      console.error("Error fetching department names", error);
    }
  }

  const handelTicketTab = (tab) => {
    setActiveTabTicket(tab);
    localStorage.setItem("activeTab", tab);
  };
  // const token = localStorage.getItem('token');
  // const { token } = useToken();

  // useEffect(() => {
  //   if (!isValidToken) {
  //     handleLogOut();
  //     // window.location.href = "/";
  //   }
  // }, [isValidToken]);

  const showToast = (message) => {
    toast.error(message);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetchSLADurations();
      if (response?.data?.statusValue === 200) {
        setSla(response.data.data);
      } else {
        setSla([]);
        toast.error(response?.data?.data?.message);
      }
    } catch (error) {
      showToast(
        `Error fetching ticket : ${error?.response?.data?.error?.message}`
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSort = (columnName) => {
    const sortedData = [...sla].sort((a, b) => {
      if (sortDirection === "asc") {
        return a[columnName] > b[columnName] ? 1 : -1;
      } else {
        return a[columnName] < b[columnName] ? 1 : -1;
      }
    });

    setSla(sortedData);
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    setSortColumn(columnName);
  };

  function convertHoursToHMS(hours) {
    const hoursInt = Math.floor(hours);
    const minutes = Math.round((hours - hoursInt) * 60);
    if (minutes === 0) {
      return `${hoursInt} Hr${hoursInt === 1 ? "" : "s"}`;
    } else if (hoursInt === 0) {
      return `${minutes} Min${minutes === 1 ? "" : "s"}`;
    } else {
      return `${hoursInt} Hr${hoursInt === 1 ? "" : "s"} ${minutes} Min${
        minutes === 1 ? "" : "s"
      }`;
    }
  }

  const defaultSLAHours = `${defaultHrs}.${defaultMins === ""?0: defaultMins / 6}`;


  const internalSLAHours = `${internalSlaHrs}.${slaMins === ""?0: slaMins / 6}`;
 
  const e1Hours = `${e1Hrs}.${e1Mins === ""? 0: e1Mins / 6}`;
 
  const e2Hours =`${e2Hrs}.${e2Mins === ""? 0: e2Mins / 6}`;

  const e3Hours = `${e3Hrs}.${e3Mins === ""? 0: e3Mins / 6}`;



  const getGroupWiseDueTime = () => {
    return selectedDepartment1?.map((dept) => {
      const hours = internalSlaHrs[dept.value] || 0;
      const minutes = slaMins[dept.value] || 0;
      const formattedTime = parseFloat(`${hours}.${(minutes / 60).toFixed(2).split('.')[1] || '00'}`);
      
      return {
        groupType: dept.value,
        time: formattedTime,
      };
    });
  };
  
  // Prepare tags
  const selectedTagValues = selectedTags?.map((tag) => tag.value) || [];
  
  const handleSubmit = async () => {
    try {
      // Convert groupWiseDueTime before API submission
      const groupWiseDueTime = getGroupWiseDueTime();
  
      // Debugging the final groupWiseDueTime before submission
      console.log("Prepared groupWiseDueTime:", groupWiseDueTime);
  
      const groupTypeValue = Array.isArray(selectedDepartment) && selectedDepartment.length > 0
        ? selectedDepartment[0]
        : selectedDepartment;
  
      const requestBody = {
        category: selectedCategories,
        subCategory: selectedSubCategories,
        defaultDueTime: parseFloat(`${defaultSLAHours}.${defaultMins || '00'}`),
        escalationTime1: parseFloat(`${e1Hours}.${e1Mins || '00'}`),
        escalationTime2: parseFloat(`${e2Hours}.${e2Mins || '00'}`),
        escalationTime3: parseFloat(`${e3Hours}.${e3Mins || '00'}`),
        visibleTo: ["cspoc", "assignee", "client"],
        workflow: workFlow,
        groupType: groupTypeValue,
        internalOnly: isInternal,
        spocOnly: spocOnly,
        isCentralLocation: isCentralLocation,
        groupWiseDueTime, // Use the prepared groupWiseDueTime
        tags: selectedTagValues,
        isIrrelevant : irrelevant
      };
      console.log("sjhfbdkjsh",editMode);

      console.log("requestBody",requestBody)
      if (editMode) {
        requestBody._id = editSlaId; // Add _id when editing
      }
  
      let response;
      if (editMode) {
      
        response = await editSla(editSlaId, requestBody);  // Send the request with the updated body
      } else {
        response = await submitSlaData(requestBody);  // For new submissions, no _id
      }
  
      if (response?.statusValue === 200) {
        toast.success(response?.message);
        fetchData(); // Refresh data after successful submission
        setShowAddSlaModal(false); // Close the modal
      } else {
        toast.error(response?.message || "Unexpected Error");
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        error.message ||
        "Unknown Error";
      toast.error(`Error: ${errorMessage}`);
      console.error("Error Details:", error?.response || error);
    }
  };
  // const handleSubmit = async () => {
  //   try {
  //     let response;
  //     if (editMode) {
  //       response = await editSla(
  //         editSlaId,
  //         selectedCategories,
  //         selectedSubCategories,
  //         defaultSLAHours,
  //         internalSLAHours,
  //         e1Hours,
  //         e2Hours,
  //         e3Hours,
  //         ["cspoc", "assignee", "client"],
  //         workFlow,
  //         selectedDepartment,
  //         isInternal,
  //         spocOnly,
  //         isCentralLocation,          
  //       );
  //     } else {
  //       response = await submitSlaData(
  //         selectedCategories,
  //         selectedSubCategories,
  //         defaultSLAHours,
  //         internalSLAHours,
  //         e1Hours,
  //         e2Hours,
  //         e3Hours,
  //         ["cspoc", "assignee", "client"],
  //         workFlow,
  //         selectedTag,
  //         selectedDepartment,
  //         isInternal,
  //         spocOnly,
  //         isCentralLocation,          
  //       );
  //     }
  //     if (response?.statusValue === 200) {
  //       toast.success(response?.message);
  //       fetchData();
  //       setShowAddSlaModal(false);
  //       clearForm(); 
  //     } else {
  //       toast.error(response?.message);
  //       setShowAddSlaModal(false);
  //       clearForm(); 
  //     }
  //   } catch (error) {
  //     showToast(
  //       `Error fetching sla data: ${error?.response?.data?.error?.message}`
  //     );
  //     clearForm(); 
  //   }
  // };

  useEffect(() => {
    console.log("editMode changed to:", editMode);
  }, [editMode]);  
  return (
    <>
      <Header />
      <div className="wrapper d-flex">
        <Sidebar
          activeTab={activeTabTicket}
          handleTabClick={handelTicketTab}
          locationData={[]}
          selectedLocation={""}
        />
      </div>
      <section className="MainContent">
        <div className="Page SLA-Duration-Page">
          <div className="PageTitle">
            <h2>SLA Durations</h2>
               {hasCategory ?
            <Link className="AddSLA_link" onClick={handleAddSlaModalShow}>
              + Add SLA
            </Link> : ""}
          </div>

          <div className="SLA-Page-Notes">
            <ul>
              <li>
                The due date for escalations and SLA is determined based on
                working hours.
              </li>
              <li>
                Each working hour is scheduled between 9 AM and 7 PM. For
                instance, if an SLA due date is set at 24 hours, it translates
                to approximately 3 working days.
              </li>
              <li>
                In some cases, SLA deadlines may precede escalations, while in
                others, escalations might take priority over SLA deadlines.
              </li>
              <li>
                SLA and Escalation timings are in hours, minutes and hours &
                minutes format. For example, durations will be shown as "2 Hrs"
                or “ 30 Mins” or "4 Hrs 30 min".
              </li>
            </ul>
          </div>

          <div className="PageContent">
            <div className="SLA-Duration_Table">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th onClick={() => handleSort("category")}>
                        <div className="theadShadow">
                          Category{" "}
                          {sortColumn === "category"
                            ? sortDirection === "asc"
                              ? "↑"
                              : "↓"
                            : ""}
                        </div>
                      </th>
                      <th onClick={() => handleSort("subCategory")}>
                        <div className="theadShadow">
                          Sub Category{" "}
                          {sortColumn === "subCategory"
                            ? sortDirection === "asc"
                              ? "↑"
                              : "↓"
                            : ""}
                        </div>
                      </th>
                      <th onClick={() => handleSort("internalOnly")}>
                        <div className="theadShadow">
                          Internal{" "}
                          {sortColumn === "internalOnly"
                            ? sortDirection === "asc"
                              ? "↑"
                              : "↓"
                            : ""}
                        </div>
                      </th>
                      <th onClick={() => handleSort("isCentralLocation")}>
                        <div className="theadShadow">
                          Central Location{" "}
                          {sortColumn === "isCentralLocation"
                            ? sortDirection === "asc"
                              ? "↑"
                              : "↓"
                            : ""}
                        </div>
                      </th>
                      <th onClick={() => handleSort("spocOnly")}>
                        <div className="theadShadow">
                          Spoc Only{" "}
                          {sortColumn === "spocOnly"
                            ? sortDirection === "asc"
                              ? "↑"
                              : "↓"
                            : ""}
                        </div>
                      </th>

                      <th onClick={() => handleSort("spocOnly")}>
                        <div className="theadShadow">
                          Is Irrelevant{" "}
                          {sortColumn === "isIrrelevant"
                            ? sortDirection === "asc"
                              ? "↑"
                              : "↓"
                            : ""}
                        </div>
                      </th>
                      <th onClick={() => handleSort("groupType")}>
                        <div className="theadShadow">
                          Department{" "}
                          {sortColumn === "groupType"
                            ? sortDirection === "asc"
                              ? "↑"
                              : "↓"
                            : ""}
                        </div>
                      </th>
                      <th onClick={() => handleSort("defaultDueTime")}>
                        <div className="theadShadow">
                          Default SLA{" "}
                          {sortColumn === "defaultDueTime"
                            ? sortDirection === "asc"
                              ? "↑"
                              : "↓"
                            : ""}
                        </div>
                      </th>
                      <th onClick={() => handleSort("escalationTime1")}>
                        <div className="theadShadow">
                          E1 Time{" "}
                          {sortColumn === "escalationTime1"
                            ? sortDirection === "asc"
                              ? "↑"
                              : "↓"
                            : ""}
                        </div>
                      </th>
                      <th onClick={() => handleSort("escalationTime2")}>
                        <div className="theadShadow">
                          E2 Time{" "}
                          {sortColumn === "escalationTime2"
                            ? sortDirection === "asc"
                              ? "↑"
                              : "↓"
                            : ""}
                        </div>
                      </th>
                      <th onClick={() => handleSort("escalationTime3")}>
                        <div className="theadShadow">
                          E3 Time{" "}
                          {sortColumn === "escalationTime3"
                            ? sortDirection === "asc"
                              ? "↑"
                              : "↓"
                            : ""}
                        </div>
                      </th>
                      {hasCategory ?
                      <th>
                        <div className="theadShadow">Action</div>
                      </th> : ""}
                    </tr>
                  </thead>

                  <tbody>
  {!loading ? (
    sla.length > 0 ? (
      sla.map((item, index) => {
        // Find the matching department option
        const department = departmentOptions.find(
          (option) => option.value === item.groupType
        );

        return (
          <tr key={index}>
            <td>{item.category}</td>
            <td>{item.subCategory}</td>
            <td>{item.internalOnly === true ? "Yes" : "No"}</td>
            <td>{item.isCentralLocation === true ? "Yes" : "No"}</td>
            <td>{item.spocOnly === true ? "Yes" : "No"}</td>
            <td>{item.isIrrelevant === true ? "Yes" : "No"}</td>
            <td>
              {/* Show the department label or fallback to empty string */}
              {department ? department.label : ""}
            </td>
            <td>{convertHoursToHMS(item.defaultDueTime)}</td>
            <td>{convertHoursToHMS(item.escalationTime1)}</td>
            <td>{convertHoursToHMS(item.escalationTime2)}</td>
            <td>{convertHoursToHMS(item.escalationTime3)}</td>
            {hasCategory ? (
              <td>
                <img
                  src={PencilIcon}
                  alt="Edit"
                  onClick={() => handleEditSlaModalShow(item)}
                  style={{ cursor: "pointer" }}
                />
              </td>
            ) : (
              ""
            )}
          </tr>
        );
      })
    ) : (
      <tr>
        <td colSpan={9}>
          <div>
            <div className="NoTicketsBox">
              <img src={NoDataBg} alt="" />
              <p className="">No data available to show</p>
            </div>
          </div>
        </td>
      </tr>
    )
  ) : (
    <tr>
      <td colSpan={9}>
        <div className="d-flex align-items-center justify-content-center heightNodData">
          <img
            src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
            width={50}
            alt="SW"
          />
        </div>
      </td>
    </tr>
  )}
</tbody>

                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Add SLA Modal  */}
      <Modal
        show={showAddSlaModal}
        onHide={handleAddSlaModalClose}
        backdrop="static"
        keyboard={false}
        dialogClassName="AddSla-modal-dialog"
        className="AddSlaModal"
        centered
        // scrollable
      >
        <Modal.Header>
          <Modal.Title>
            <span>*</span> Please fill following information
          </Modal.Title>
          <a
            type="button"
            className="AddSLA_Close btn-close"
            aria-label="Close"
            onClick={handleAddSlaModalClose}
          >
            {" "}
            &nbsp;{" "}
          </a>
        </Modal.Header>
        <Modal.Body>
          <div className="AddSLAFeilds">
            <div className="AddSLARow">
              <label>Department</label>
              <Form.Select
                aria-label="Default select example"
                value={selectedDepartment}
                onChange={(e) => setSelectedDepartment([e.target.value])}
              >
                <option>Select Department</option>
                {departmentOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div className="AddSLARow">
              <label>Category</label>

              <Form.Control
                type="text"
                value={selectedCategories}
                onChange={(e) => setSelectedCategories(e.target.value)}
                placeholder="Enter Category"
                list="category-options"
              />
            </div>

            <div className="AddSLARow">
              <label>Sub-category</label>

              <Form.Control
                type="text"
                value={selectedSubCategories}
                onChange={(e) => setSelectedSubCategories(e.target.value)}
                placeholder="Enter Sub Category"
                list="sub-category-options"
              />
            </div>

            <div className="AddSLARow">
              <label>Workflow</label>
              <Form.Select
                value={workFlow}
                onChange={(e) => setWorkFlow(e.target.value)}
              >
                <option value="">Select Workflow</option>
                {workflowOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </div>
            <div className="AddSLARow">
      <label>Tag</label>
      <MultiSelect
        options={tagOptions}  // Dynamically populated options
        value={selectedTags}  // The selected values will be stored here
        onChange={setSelectedTags}  // Update selected tags on change
        labelledBy="Select"  // Label for the MultiSelect component
      />
    </div>

            <div className="AddSLARow">
              <label>Internal</label>
              <div className="d-flex align-items-center AddSlaInternalRadio">
                <Form.Check
                  type="radio"
                  label="Yes"
                  name="internalCheck"
                  id="internalCheckYes"
                  checked={isInternal}
                  onChange={() => setIsInternal(true)}
                />
                <Form.Check
                  type="radio"
                  label="No"
                  name="internalCheck"
                  id="internalCheckNo"
                  checked={!isInternal}
                  onChange={() => setIsInternal(false)}
                />
              </div>
            </div>


            <div className="AddSLARow">
              <label>Central Location</label>
              <div className="d-flex align-items-center AddSlaInternalRadio">
                <Form.Check
                  type="radio"
                  label="Yes"
               
                  checked={isCentralLocation}
                  onChange={() => setIsCentralLocation(true)}
                />
                <Form.Check
                  type="radio"
                  label="No"
               
                  checked={!isCentralLocation}
                  onChange={() => setIsCentralLocation(false)}
                />
              </div>
            </div>


            <div className="AddSLARow">
              <label>Spoc Only</label>
              <div className="d-flex align-items-center AddSlaInternalRadio">
                <Form.Check
                  type="radio"
                  label="Yes"
               
                  checked={spocOnly}
                  onChange={() => setSpocOnly(true)}
                />
                <Form.Check
                  type="radio"
                  label="No"
               
                  checked={!spocOnly}
                  onChange={() => setSpocOnly(false)}
                />
              </div>
            </div>



            <div className="AddSLARow">
              <label>Is Irrelevant</label>
              <div className="d-flex align-items-center AddSlaInternalRadio">
                <Form.Check
                  type="radio"
                  label="Yes"
               
                  checked={irrelevant}
                  onChange={() => setIrrelevant(true)}
                />
                <Form.Check
                  type="radio"
                  label="No"
               
                  checked={!irrelevant}
                  onChange={() => setIrrelevant(false)}
                />
              </div>
            </div>
        
       
         


            <div className="AddSLARow">
              <label>Default SLA</label>
              <div className="AddSLA_TimeRow">
                <div className="HoursInput">
                  <Form.Control
                    type="number"
                    min="0"
                    value={defaultHrs}
                    onChange={handleHoursChange}
                    placeholder="Hours"
                  />
                </div>
                <div className="MinutesSelect">
                  <Form.Select
                    value={defaultMins}
                    onChange={handleMinutesChange}
                  >
                    <option value="" disabled selected>
                      Minutes
                    </option>
                    {generateMinuteOptions()}
                  </Form.Select>
                </div>

              </div>
            </div>
    
            <div className="AddSLARow">
              <label>E1</label>
              <div className="AddSLA_TimeRow">
                <div className="HoursInput">
                  <Form.Control
                    type="number"
                     min="0"
                    value={e1Hrs}
                    onChange={handleE1HoursChange}
                    placeholder="Hours"
                  />
                </div>

                <div className="MinutesSelect">
                  <Form.Select value={e1Mins} onChange={handleE1MinutesChange}>
                    <option value="">Minutes</option>
                    {generateMinuteOptions()}
                  </Form.Select>
                </div>
              </div>
            </div>

            <div className="AddSLARow">
              <label>E2</label>
              <div className="AddSLA_TimeRow">
                <div className="HoursInput">
                  <Form.Control
                    type="number"
                    min="0"
                    value={e2Hrs}
                    onChange={handleE2HoursChange}
                    placeholder="Hours"
                  />
                </div>
                <div className="MinutesSelect">
                  <Form.Select value={e2Mins} onChange={handleE2MinutesChange}>
                    <option value="">Minutes</option>
                    {generateMinuteOptions()}
                  </Form.Select>
                </div>
              </div>
            </div>

            <div className="AddSLARow">
              <label>E3</label>
              <div className="AddSLA_TimeRow">
                <div className="HoursInput">
                  <Form.Control
                    type="number"
                    min="0"
                    value={e3Hrs}
                    onChange={handleE3HoursChange}
                    placeholder="Hours"
                  />
                </div>

                <div className="MinutesSelect">
                  <Form.Select value={e3Mins} onChange={handleE3MinutesChange}>
                    <option value="">Minutes</option>
                    {generateMinuteOptions()}
                  </Form.Select>
                </div>
              </div>
            </div>




            <div className="AddSLARow">
        <div className="PageTitle">
          <Link className="AddSLA_link" style={{ cursor: 'pointer' }}>
            Add Internal SLA
          </Link>
        </div>
      </div>

      <div className="AddSLARow">
       
        <MultiSelect
          options={departmentOptions}
          value={selectedDepartment1}
          onChange={(selected) => {
    console.log('sharfe', selected);  // Log the selected value
    setSelectedDepartment1(selected);  // Set to selected departments
  }}
          labelledBy="Select Departments"
        />
      </div>
      {console.log("departmentOptions",selectedDepartment)}
  {/* Render inputs based on selected departments */}
  {Array.isArray(selectedDepartment1) && selectedDepartment1.map((dept) => (
  <div className="AddSLARow" key={dept._id || dept.value}>
    <label>{editMode ? dept?.value?.toUpperCase() : dept?.label?.toUpperCase()} Team SLA</label>
    <div className="AddSLA_TimeRow">
      
      {/* Hours Input */}
      <div className="HoursInput">
        <Form.Control
          type="number"
          min="0"
          value={internalSlaHrs[dept.value] || ''} // Use dept.value for consistency
          onChange={(e) => handleSlaHoursChange(e.target.value, dept.value)}
          placeholder="Hours"
        />
      </div>

      {/* Minutes Select */}
      <div className="MinutesSelect">
        <Form.Select
          value={slaMins[dept.value] || ''}
          onChange={(e) => handleMinutesSlaChange(e.target.value, dept.value)}
        >
          <option value="" disabled>Minutes</option>
          {generateMinuteOptions()}
        </Form.Select>
      </div>
    </div>
  </div>
))}
          </div>
        </Modal.Body>  
        <Modal.Footer>
          <div className="ModalCTA">
            <Button
              className="btn btn-dark ModalCTA_Dark"
              onClick={handleSubmit}
              disabled={(typeof selectedCategories === 'string' && selectedCategories.trim() === "") || selectedSubCategories.length === 0 ||
                selectedDepartment?.length === 0 || (typeof workFlow === 'string' && workFlow.trim() === "") || 
                (typeof defaultHrs === 'string' && defaultHrs.trim() === "") ||  (typeof e1Hrs === 'string' && e1Hrs.trim() === "")
                ||  (typeof e2Hrs === 'string' && e2Hrs.trim() === "") ||  (typeof e3Hrs === 'string' && e3Hrs.trim() === "")
              }
             
            >
              Submit
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SLADurations;
